import request from '@/utils/request'

// 获取首页数据
export const getHomeData = (pageNo, pageSize) => {
	return request.get(`/client/user/oaNotify/list?pageNo=${pageNo}&pageSize=${pageSize}`, {
	})
}